/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import type { BANNERTYPEENUM } from "./BANNERTYPEENUM";
import { BANNERTYPEENUMFromJSON, BANNERTYPEENUMFromJSONTyped, BANNERTYPEENUMToJSON } from "./BANNERTYPEENUM";
import type { GenericIdDTO } from "./GenericIdDTO";
import { GenericIdDTOFromJSON, GenericIdDTOFromJSONTyped, GenericIdDTOToJSON } from "./GenericIdDTO";
import type { ImageDTO } from "./ImageDTO";
import { ImageDTOFromJSON, ImageDTOFromJSONTyped, ImageDTOToJSON } from "./ImageDTO";
import type { PlatformRefDTO } from "./PlatformRefDTO";
import { PlatformRefDTOFromJSON, PlatformRefDTOFromJSONTyped, PlatformRefDTOToJSON } from "./PlatformRefDTO";

/**
 *
 * @export
 * @interface PutBannerDTO
 */
export interface PutBannerDTO {
  /**
   *
   * @type {PlatformRefDTO}
   * @memberof PutBannerDTO
   */
  platform: PlatformRefDTO;
  /**
   *
   * @type {string}
   * @memberof PutBannerDTO
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof PutBannerDTO
   */
  cta?: string;
  /**
   *
   * @type {string}
   * @memberof PutBannerDTO
   */
  label?: string;
  /**
   *
   * @type {ImageDTO}
   * @memberof PutBannerDTO
   */
  bannerImage?: ImageDTO;
  /**
   *
   * @type {ImageDTO}
   * @memberof PutBannerDTO
   */
  logoImage?: ImageDTO;
  /**
   *
   * @type {string}
   * @memberof PutBannerDTO
   */
  url?: string;
  /**
   *
   * @type {string}
   * @memberof PutBannerDTO
   */
  name: string;
  /**
   *
   * @type {Array<GenericIdDTO>}
   * @memberof PutBannerDTO
   */
  brands?: Array<GenericIdDTO>;
  /**
   *
   * @type {Array<GenericIdDTO>}
   * @memberof PutBannerDTO
   */
  categories?: Array<GenericIdDTO>;
  /**
   *
   * @type {BANNERTYPEENUM}
   * @memberof PutBannerDTO
   */
  type?: BANNERTYPEENUM | null;
  /**
   *
   * @type {string}
   * @memberof PutBannerDTO
   */
  startDate?: string | null;
  /**
   *
   * @type {string}
   * @memberof PutBannerDTO
   */
  endDate?: string | null;
  /**
   *
   * @type {number}
   * @memberof PutBannerDTO
   */
  id: number;
}

/**
 * Check if a given object implements the PutBannerDTO interface.
 */
export function instanceOfPutBannerDTO(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && "platform" in value;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "id" in value;

  return isInstance;
}

export function PutBannerDTOFromJSON(json: any): PutBannerDTO {
  return PutBannerDTOFromJSONTyped(json, false);
}

export function PutBannerDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): PutBannerDTO {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    platform: PlatformRefDTOFromJSON(json["platform"]),
    description: !exists(json, "description") ? undefined : json["description"],
    cta: !exists(json, "cta") ? undefined : json["cta"],
    label: !exists(json, "label") ? undefined : json["label"],
    bannerImage: !exists(json, "bannerImage") ? undefined : ImageDTOFromJSON(json["bannerImage"]),
    logoImage: !exists(json, "logoImage") ? undefined : ImageDTOFromJSON(json["logoImage"]),
    url: !exists(json, "url") ? undefined : json["url"],
    name: json["name"],
    brands: !exists(json, "brands") ? undefined : (json["brands"] as Array<any>).map(GenericIdDTOFromJSON),
    categories: !exists(json, "categories") ? undefined : (json["categories"] as Array<any>).map(GenericIdDTOFromJSON),
    type: !exists(json, "type") ? undefined : BANNERTYPEENUMFromJSON(json["type"]),
    startDate: !exists(json, "startDate") ? undefined : json["startDate"],
    endDate: !exists(json, "endDate") ? undefined : json["endDate"],
    id: json["id"]
  };
}

export function PutBannerDTOToJSON(value?: PutBannerDTO | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    platform: PlatformRefDTOToJSON(value.platform),
    description: value.description,
    cta: value.cta,
    label: value.label,
    bannerImage: ImageDTOToJSON(value.bannerImage),
    logoImage: ImageDTOToJSON(value.logoImage),
    url: value.url,
    name: value.name,
    brands: value.brands === undefined ? undefined : (value.brands as Array<any>).map(GenericIdDTOToJSON),
    categories: value.categories === undefined ? undefined : (value.categories as Array<any>).map(GenericIdDTOToJSON),
    type: BANNERTYPEENUMToJSON(value.type),
    startDate: value.startDate,
    endDate: value.endDate,
    id: value.id
  };
}
